import { getRoutePathForView, ROUTES } from "app/helpers/routerPathHelper";
import { SessionHelper } from "app/helpers/sessionHelper";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import VerificationStatus from "../VerificationStatus/VerificationStatus";

const AccountMenuList = (props: {
  verifiedStatus: boolean;
  verifiedStatusFormatedText: React.ReactNode;
}) => {
  const { verifiedStatus, verifiedStatusFormatedText } = props;
  const link = getRoutePathForView();

  return (
    <ul className="account-menu-ul">
      <li
        className="account-menu-li account-menu-li__no-padding"
        data-qa="account__verification-link"
      >
        <Link
          to={
            SessionHelper.isAsianRouteAndSessionView()
              ? ROUTES.asianAccountVerification
              : ROUTES.accountVerification
          }
          className={`row account-menu--status ${
            verifiedStatus ? "verified" : "unverified"
          }`}
        >
          <span className="account-menu--status__label">
            <FormattedMessage tagName="span" id="account-verification-title" />
          </span>
          <VerificationStatus
            verifiedStatus={verifiedStatus}
            verifiedStatusFormatedText={verifiedStatusFormatedText}
          />
        </Link>
      </li>
      <li
        className="account-menu-li account-menu-li__no-padding"
        data-qa="account__details-link"
      >
        <Link
          to={
            SessionHelper.isAsianRouteAndSessionView()
              ? ROUTES.asianProfile
              : ROUTES.profile
          }
          className="account-menu__link account-menu__link--padding"
          id="account_button"
        >
          <FormattedMessage tagName="span" id="account-links-account-details" />
        </Link>
      </li>
      <li
        className="account-menu-li account-menu-li__no-padding"
        data-qa="account__funding-link"
      >
        <Link
          to={link}
          className="account-menu__link account-menu__link--padding"
          id="manage-funding_button"
        >
          <FormattedMessage tagName="span" id="account-links-funding" />
        </Link>
      </li>
      <li
        className="account-menu-li account-menu-li__no-padding"
        data-qa="account__controls-link"
      >
        <Link
          to={"controls/"}
          className="account-menu__link account-menu__link--padding"
          id="account-controls_button"
        >
          <FormattedMessage tagName="span" id="account-links-controls" />
        </Link>
      </li>
      <li
        className="account-menu-li account-menu-li__no-padding"
        data-qa="account__help-and-learning-link"
      >
        <Link
          to={
            SessionHelper.isAsianRouteAndSessionView()
              ? ROUTES.asianHelpAndLearning
              : ROUTES.helpAndLearning
          }
          className="account-menu__link account-menu__link--padding"
          id="help-and-learning-button"
        >
          <FormattedMessage tagName="span" id="account-helpandlearning" />
        </Link>
      </li>
    </ul>
  );
};

export default AccountMenuList;
